import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-top: 30px;
`

export const MapWrapper = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  margin-bottom: 30px;
`

export const MapWrapperOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: orange;
`

export const MapWrapperOverlayText = styled.div`
  text-align: center;
`
